var map = {
	"./boosterShop.png": "56b7",
	"./level2.png": "516e",
	"./level3.png": "0987",
	"./moist.png": "5f36",
	"./shop-back.png": "f162",
	"./shop-front-mobile.png": "dec1",
	"./shop-front.png": "6376",
	"./venus.png": "1968"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d69";